module.exports = __webpack_public_path__ + "static/pakmaya-my-web-554367ed481aebd03e716e27a5f01038.jpg";